import { useState } from "react";
import { faqs } from "@/mocks/comic";

export default function Faq() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-600">
            <i className="ri-question-answer-line"></i>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            关于静漫天堂，你想知道的
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            整理了大家最常询问的问题，帮助你更快上手使用高清静态漫画图源。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((f) => {
            const open = openId === f.id;
            return (
              <div
                key={f.id}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open
                    ? "border-primary-200 bg-background-50"
                    : "border-background-200/70 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? null : f.id)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-sm font-medium whitespace-normal text-foreground-950 md:text-base">
                    {f.q}
                  </h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg transition-all ${
                      open
                        ? "rotate-180 bg-primary-500 text-background-50"
                        : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}